import { pxToRem } from '@group-link-one/gl-components';

import {
  exportVariables,
  type UTColorsVariables,
  type UTColorVariable,
  type UTSizeVariable,
  type UTSizeVariables,
} from '@group-link-one/gl-ui/utilities';

const WaterLightVariables: UTColorsVariables = {
  ACCENT: {
    ACCENT_COLOR_PRIMARY_BACKGROUND: '#0033FF',
    ACCENT_COLOR_PRIMARY_TEXT: '#0033FF',
    ACCENT_COLOR_PRIMARY_STROKE: '#0033FF',
    ACCENT_COLOR_PRIMARY_BACKGROUND_50: '#7F98FF',
    ACCENT_COLOR_PRIMARY_TEXT_50: '#7F98FF',
    ACCENT_COLOR_PRIMARY_STROKE_50: '#7F98FF',
    ACCENT_COLOR_PRIMARY_BACKGROUND_25: '#BFCCFF',
    ACCENT_COLOR_PRIMARY_TEXT_25: '#BFCCFF',
    ACCENT_COLOR_PRIMARY_STROKE_25: '#BFCCFF',
    ACCENT_COLOR_PRIMARY_BACKGROUND_10: '#E6EBFF',
    ACCENT_COLOR_PRIMARY_STROKE_10: '#E6EBFF',
    ACCENT_COLOR_SECONDARY_BACKGROUND: '#7523D7',
    ACCENT_COLOR_SECONDARY_TEXT: '#7523D7',
    ACCENT_COLOR_SECONDARY_STROKE: '#7523D7',
    ACCENT_COLOR_SECONDARY_BACKGROUND_50: '#B990EA',
    ACCENT_COLOR_SECONDARY_TEXT_50: '#B990EA',
    ACCENT_COLOR_SECONDARY_STROKE_50: '#B990EA',
    ACCENT_COLOR_SECONDARY_BACKGROUND_25: '#DCC8F5',
    ACCENT_COLOR_SECONDARY_TEXT_25: '#DCC8F5',
    ACCENT_COLOR_SECONDARY_STROKE_25: '#DCC8F5',
    ACCENT_COLOR_SECONDARY_BACKGROUND_10: '#F2E9FB',
    ACCENT_COLOR_SECONDARY_STROKE_10: '#F2E9FB',
    ACCENT_COLOR_TERTIARY_BACKGROUND: '#201F5D',
    ACCENT_COLOR_TERTIARY_TEXT: '#201F5D',
    ACCENT_COLOR_TERTIARY_STROKE: '#201F5D',
    ACCENT_COLOR_TERTIARY_BACKGROUND_50: '#8F8EAD',
    ACCENT_COLOR_TERTIARY_TEXT_50: '#8F8EAD',
    ACCENT_COLOR_TERTIARY_STROKE_50: '#8F8EAD',
    ACCENT_COLOR_TERTIARY_BACKGROUND_25: '#C7C7D6',
    ACCENT_COLOR_TERTIARY_TEXT_25: '#C7C7D6',
    ACCENT_COLOR_TERTIARY_STROKE_25: '#C7C7D6',
    ACCENT_COLOR_TERTIARY_BACKGROUND_10: '#E9E9EF',
    ACCENT_COLOR_TERTIARY_STROKE_10: '#E9E9EF',
  },
  COLOR: {
    COLOR_PRIMARY_BACKGROUND: '#00DCFF',
    COLOR_PRIMARY_TEXT: '#00DCFF',
    COLOR_PRIMARY_STROKE: '#00DCFF',
    COLOR_PRIMARY_BACKGROUND_50: '#7FEDFF',
    COLOR_PRIMARY_TEXT_50: '#7FEDFF',
    COLOR_PRIMARY_STROKE_50: '#7FEDFF',
    COLOR_PRIMARY_BACKGROUND_25: '#BFF6FF',
    COLOR_PRIMARY_TEXT_25: '#BFF6FF',
    COLOR_PRIMARY_STROKE_25: '#BFF6FF',
    COLOR_PRIMARY_BACKGROUND_10: '#E6FCFF',
    COLOR_PRIMARY_STROKE_10: '#E6FCFF',
    COLOR_SECONDARY_BACKGROUND: '#00FFAA',
    COLOR_SECONDARY_TEXT: '#00FFAA',
    COLOR_SECONDARY_STROKE: '#00FFAA',
    COLOR_SECONDARY_BACKGROUND_50: '#7FFFD4',
    COLOR_SECONDARY_TEXT_50: '#7FFFD4',
    COLOR_SECONDARY_STROKE_50: '#7FFFD4',
    COLOR_SECONDARY_BACKGROUND_25: '#BFFFE9',
    COLOR_SECONDARY_TEXT_25: '#BFFFE9',
    COLOR_SECONDARY_STROKE_25: '#BFFFE9',
    COLOR_SECONDARY_BACKGROUND_10: '#E6FFF7',
    COLOR_SECONDARY_STROKE_10: '#E6FFF7',
    COLOR_TERTIARY_BACKGROUND: '#FF925B',
    COLOR_TERTIARY_TEXT: '#FF925B',
    COLOR_TERTIARY_STROKE: '#FF925B',
    COLOR_TERTIARY_BACKGROUND_10: '#FFF5EF',
    COLOR_TERTIARY_STROKE_10: '#FFF5EF',
    COLOR_QUATERNARY_BACKGROUND: '#262626',
    COLOR_QUINARY_BACKGROUND: '#FFFFFF',
  },
  BASE: {
    BASE_COLOR_PRIMARY_BACKGROUND: '#313337',
    BASE_COLOR_PRIMARY_TEXT: '#313337',
    BASE_COLOR_PRIMARY_STROKE: '#313337',
    BASE_COLOR_SECONDARY_BACKGROUND: '#58616A',
    BASE_COLOR_SECONDARY_TEXT: '#58616A',
    BASE_COLOR_SECONDARY_STROKE: '#58616A',
    BASE_COLOR_TERTIARY_BACKGROUND: '#888E9E',
    BASE_COLOR_TERTIARY_TEXT: '#888E9E',
    BASE_COLOR_TERTIARY_STROKE: '#888E9E',
    BASE_COLOR_QUATERNARY_BACKGROUND: '#B2BDC5',
    BASE_COLOR_QUATERNARY_TEXT: '#B2BDC5',
    BASE_COLOR_QUATERNARY_STROKE: '#B2BDC5',
    BASE_COLOR_QUINARY_BACKGROUND: '#E2E8EF',
    BASE_COLOR_QUINARY_TEXT: '#E2E8EF',
    BASE_COLOR_QUINARY_STROKE: '#E2E8EF',
    BASE_COLOR_SENARY_BACKGROUND: '#F5F8F9',
    BASE_COLOR_SENARY_TEXT: '#F5F8F9',
    BASE_COLOR_SENARY_STROKE: '#F5F8F9',
  },
  WARNING: {
    WARNING_COLOR_PRIMARY_BACKGROUND: '#00893C',
    WARNING_COLOR_PRIMARY_TEXT: '#00893C',
    WARNING_COLOR_PRIMARY_STROKE: '#00893C',
    WARNING_COLOR_PRIMARY_BACKGROUND_90: '#1A9550',
    WARNING_COLOR_PRIMARY_STROKE_90: '#1A9550',
    WARNING_COLOR_PRIMARY_BACKGROUND_75: '#40A76D',
    WARNING_COLOR_PRIMARY_STROKE_75: '#40A76D',
    WARNING_COLOR_PRIMARY_BACKGROUND_50: '#7FC39D',
    WARNING_COLOR_PRIMARY_STROKE_50: '#7FC39D',
    WARNING_COLOR_PRIMARY_BACKGROUND_25: '#BFE1CE',
    WARNING_COLOR_PRIMARY_STROKE_25: '#BFE1CE',
    WARNING_COLOR_PRIMARY_BACKGROUND_10: '#E6F4EC',
    WARNING_COLOR_PRIMARY_STROKE_10: '#E6F4EC',
    WARNING_COLOR_SECONDARY_BACKGROUND: '#E4A700',
    WARNING_COLOR_SECONDARY_TEXT: '#E4A700',
    WARNING_COLOR_SECONDARY_STROKE: '#E4A700',
    WARNING_COLOR_SECONDARY_BACKGROUND_90: '#E7B01A',
    WARNING_COLOR_SECONDARY_STROKE_90: '#E7B01A',
    WARNING_COLOR_SECONDARY_BACKGROUND_75: '#EBBD40',
    WARNING_COLOR_SECONDARY_STROKE_75: '#EBBD40',
    WARNING_COLOR_SECONDARY_BACKGROUND_50: '#F1D27F',
    WARNING_COLOR_SECONDARY_STROKE_50: '#F1D27F',
    WARNING_COLOR_SECONDARY_BACKGROUND_25: '#F8E9BF',
    WARNING_COLOR_SECONDARY_STROKE_25: '#F8E9BF',
    WARNING_COLOR_SECONDARY_BACKGROUND_10: '#FDF7E6',
    WARNING_COLOR_SECONDARY_STROKE_10: '#FDF7E6',
    WARNING_COLOR_TERTIARY_BACKGROUND: '#E12C57',
    WARNING_COLOR_TERTIARY_TEXT: '#E12C57',
    WARNING_COLOR_TERTIARY_STROKE: '#E12C57',
    WARNING_COLOR_TERTIARY_BACKGROUND_90: '#E44268',
    WARNING_COLOR_TERTIARY_STROKE_90: '#E44268',
    WARNING_COLOR_TERTIARY_BACKGROUND_75: '#E96181',
    WARNING_COLOR_TERTIARY_STROKE_75: '#E96181',
    WARNING_COLOR_TERTIARY_BACKGROUND_50: '#EF95AA',
    WARNING_COLOR_TERTIARY_STROKE_50: '#EF95AA',
    WARNING_COLOR_TERTIARY_BACKGROUND_25: '#F7CAD5',
    WARNING_COLOR_TERTIARY_STROKE_25: '#F7CAD5',
    WARNING_COLOR_TERTIARY_BACKGROUND_10: '#FCEAEF',
    WARNING_COLOR_TERTIARY_STROKE_10: '#FCEAEF',
  },
};

const WaterDarkVariables: UTColorsVariables = {
  ACCENT: {
    ACCENT_COLOR_PRIMARY_BACKGROUND: '#00DCFF',
    ACCENT_COLOR_PRIMARY_TEXT: '#00DCFF',
    ACCENT_COLOR_PRIMARY_STROKE: '#00DCFF',
    ACCENT_COLOR_PRIMARY_BACKGROUND_50: '#7F98FF',
    ACCENT_COLOR_PRIMARY_TEXT_50: '#F5F8F9',
    ACCENT_COLOR_PRIMARY_STROKE_50: '#7F98FF',
    ACCENT_COLOR_PRIMARY_BACKGROUND_25: '#BFCCFF',
    ACCENT_COLOR_PRIMARY_TEXT_25: '#F5F8F9',
    ACCENT_COLOR_PRIMARY_STROKE_25: '#BFCCFF',
    ACCENT_COLOR_PRIMARY_BACKGROUND_10: '#262626',
    ACCENT_COLOR_PRIMARY_STROKE_10: '#E6EBFF',
    ACCENT_COLOR_SECONDARY_BACKGROUND: '#B990EA',
    ACCENT_COLOR_SECONDARY_TEXT: '#F5F8F9',
    ACCENT_COLOR_SECONDARY_STROKE: '#B990EA',
    ACCENT_COLOR_SECONDARY_BACKGROUND_50: '#DCC8F5',
    ACCENT_COLOR_SECONDARY_TEXT_50: '#F5F8F9',
    ACCENT_COLOR_SECONDARY_STROKE_50: '#DCC8F5',
    ACCENT_COLOR_SECONDARY_BACKGROUND_25: '#F2E9FB',
    ACCENT_COLOR_SECONDARY_TEXT_25: '#F2E9FB',
    ACCENT_COLOR_SECONDARY_STROKE_25: '#F2E9FB',
    ACCENT_COLOR_SECONDARY_BACKGROUND_10: '#F2E9FB',
    ACCENT_COLOR_SECONDARY_STROKE_10: '#F2E9FB',
    ACCENT_COLOR_TERTIARY_BACKGROUND: '#7F98FF',
    ACCENT_COLOR_TERTIARY_TEXT: '#F5F8F9',
    ACCENT_COLOR_TERTIARY_STROKE: '#00DCFF',
    ACCENT_COLOR_TERTIARY_BACKGROUND_50: '#8F8EAD',
    ACCENT_COLOR_TERTIARY_TEXT_50: '#F5F8F9',
    ACCENT_COLOR_TERTIARY_STROKE_50: '#8F8EAD',
    ACCENT_COLOR_TERTIARY_BACKGROUND_25: '#C7C7D6',
    ACCENT_COLOR_TERTIARY_TEXT_25: '#F5F8F9',
    ACCENT_COLOR_TERTIARY_STROKE_25: '#C7C7D6',
    ACCENT_COLOR_TERTIARY_BACKGROUND_10: '#58616A',
    ACCENT_COLOR_TERTIARY_STROKE_10: '#E9E9EF',
  },
  COLOR: {
    COLOR_PRIMARY_BACKGROUND: '#00DCFF',
    COLOR_PRIMARY_TEXT: '#00DCFF',
    COLOR_PRIMARY_STROKE: '#00DCFF',
    COLOR_PRIMARY_BACKGROUND_50: '#7FEDFF',
    COLOR_PRIMARY_TEXT_50: '#7FEDFF',
    COLOR_PRIMARY_STROKE_50: '#7FEDFF',
    COLOR_PRIMARY_BACKGROUND_25: '#BFF6FF',
    COLOR_PRIMARY_TEXT_25: '#BFF6FF',
    COLOR_PRIMARY_STROKE_25: '#BFF6FF',
    COLOR_PRIMARY_BACKGROUND_10: '#E6FCFF',
    COLOR_PRIMARY_STROKE_10: '#E6FCFF',
    COLOR_SECONDARY_BACKGROUND: '#00FFAA',
    COLOR_SECONDARY_TEXT: '#00FFAA',
    COLOR_SECONDARY_STROKE: '#00FFAA',
    COLOR_SECONDARY_BACKGROUND_50: '#7FFFD4',
    COLOR_SECONDARY_TEXT_50: '#7FFFD4',
    COLOR_SECONDARY_STROKE_50: '#7FFFD4',
    COLOR_SECONDARY_BACKGROUND_25: '#BFFFE9',
    COLOR_SECONDARY_TEXT_25: '#BFFFE9',
    COLOR_SECONDARY_STROKE_25: '#BFFFE9',
    COLOR_SECONDARY_BACKGROUND_10: '#E6FFF7',
    COLOR_SECONDARY_STROKE_10: '#E6FFF7',
    COLOR_TERTIARY_BACKGROUND: '#FF925B',
    COLOR_TERTIARY_TEXT: '#F5F8F9',
    COLOR_TERTIARY_STROKE: '#FF925B',
    COLOR_TERTIARY_BACKGROUND_10: '#FFF5EF',
    COLOR_TERTIARY_STROKE_10: '#FFF5EF',
    COLOR_QUATERNARY_BACKGROUND: '#262626',
    COLOR_QUINARY_BACKGROUND: '#313337',
  },
  BASE: {
    BASE_COLOR_PRIMARY_BACKGROUND: '#313337',
    BASE_COLOR_PRIMARY_TEXT: '#F5F8F9',
    BASE_COLOR_PRIMARY_STROKE: '#F5F8F9',
    BASE_COLOR_SECONDARY_BACKGROUND: '#58616A',
    BASE_COLOR_SECONDARY_TEXT: '#F5F8F9',
    BASE_COLOR_SECONDARY_STROKE: '#B2BDC5',
    BASE_COLOR_TERTIARY_BACKGROUND: '#888E9E',
    BASE_COLOR_TERTIARY_TEXT: '#F5F8F9',
    BASE_COLOR_TERTIARY_STROKE: '#888E9E',
    BASE_COLOR_QUATERNARY_BACKGROUND: '#B2BDC5',
    BASE_COLOR_QUATERNARY_TEXT: '#58616A',
    BASE_COLOR_QUATERNARY_STROKE: '#888E9E',
    BASE_COLOR_QUINARY_BACKGROUND: '#313337',
    BASE_COLOR_QUINARY_TEXT: '#E2E8EF',
    BASE_COLOR_QUINARY_STROKE: '#58616A',
    BASE_COLOR_SENARY_BACKGROUND: '#313337',
    BASE_COLOR_SENARY_TEXT: '#313337',
    BASE_COLOR_SENARY_STROKE: '#313337',
  },
  WARNING: {
    WARNING_COLOR_PRIMARY_BACKGROUND: '#00893C',
    WARNING_COLOR_PRIMARY_TEXT: '#00893C',
    WARNING_COLOR_PRIMARY_STROKE: '#00893C',
    WARNING_COLOR_PRIMARY_BACKGROUND_90: '#1A9550',
    WARNING_COLOR_PRIMARY_STROKE_90: '#1A9550',
    WARNING_COLOR_PRIMARY_BACKGROUND_75: '#40A76D',
    WARNING_COLOR_PRIMARY_STROKE_75: '#40A76D',
    WARNING_COLOR_PRIMARY_BACKGROUND_50: '#7FC39D',
    WARNING_COLOR_PRIMARY_STROKE_50: '#7FC39D',
    WARNING_COLOR_PRIMARY_BACKGROUND_25: '#BFE1CE',
    WARNING_COLOR_PRIMARY_STROKE_25: '#BFE1CE',
    WARNING_COLOR_PRIMARY_BACKGROUND_10: '#E6F4EC',
    WARNING_COLOR_PRIMARY_STROKE_10: '#E6F4EC',
    WARNING_COLOR_SECONDARY_BACKGROUND: '#E4A700',
    WARNING_COLOR_SECONDARY_TEXT: '#E4A700',
    WARNING_COLOR_SECONDARY_STROKE: '#E4A700',
    WARNING_COLOR_SECONDARY_BACKGROUND_90: '#E7B01A',
    WARNING_COLOR_SECONDARY_STROKE_90: '#E7B01A',
    WARNING_COLOR_SECONDARY_BACKGROUND_75: '#EBBD40',
    WARNING_COLOR_SECONDARY_STROKE_75: '#EBBD40',
    WARNING_COLOR_SECONDARY_BACKGROUND_50: '#F1D27F',
    WARNING_COLOR_SECONDARY_STROKE_50: '#F1D27F',
    WARNING_COLOR_SECONDARY_BACKGROUND_25: '#F8E9BF',
    WARNING_COLOR_SECONDARY_STROKE_25: '#F8E9BF',
    WARNING_COLOR_SECONDARY_BACKGROUND_10: '#FDF7E6',
    WARNING_COLOR_SECONDARY_STROKE_10: '#FDF7E6',
    WARNING_COLOR_TERTIARY_BACKGROUND: '#E12C57',
    WARNING_COLOR_TERTIARY_TEXT: '#E12C57',
    WARNING_COLOR_TERTIARY_STROKE: '#E12C57',
    WARNING_COLOR_TERTIARY_BACKGROUND_90: '#E44268',
    WARNING_COLOR_TERTIARY_STROKE_90: '#E44268',
    WARNING_COLOR_TERTIARY_BACKGROUND_75: '#E96181',
    WARNING_COLOR_TERTIARY_STROKE_75: '#E96181',
    WARNING_COLOR_TERTIARY_BACKGROUND_50: '#EF95AA',
    WARNING_COLOR_TERTIARY_STROKE_50: '#EF95AA',
    WARNING_COLOR_TERTIARY_BACKGROUND_25: '#F7CAD5',
    WARNING_COLOR_TERTIARY_STROKE_25: '#F7CAD5',
    WARNING_COLOR_TERTIARY_BACKGROUND_10: '#FCEAEF',
    WARNING_COLOR_TERTIARY_STROKE_10: '#FCEAEF',
  },
};

const WaterSizeVariables: UTSizeVariables = {
  SPACING: {
    BASE: '16px',
    XXS: '2px',
    XS: '4px',
    S: '6px',
    SM: '10px',
    M: '14px',
    ML: '20px',
    L: '28px',
    XL: '40px',
  },
  RADIUS: {
    SHARP: '0px',
    XXS: '2px',
    XS: '2px',
    S: '4px',
    SM: '6px',
    M: '10px',
    ML: '16px',
    LG: '24px',
    XL: '36px',
    ROUND: '50%',
  },
  FONT_SIZE: {
    HEADLINE_1: pxToRem('83px'),
    HEADLINE_2: pxToRem('69px'),
    HEADLINE_3: pxToRem('57px'),
    HEADLINE_4: pxToRem('48px'),
    HEADLINE_5: pxToRem('40px'),
    HEADLINE_6: pxToRem('33px'),
    SUBTITLE_1: pxToRem('28px'),
    SUBTITLE_2: pxToRem('23px'),
    BODY_1: pxToRem('19px'),
    BODY_2: pxToRem('16px'),
    CAPTION: pxToRem('13px'),
    OVERLINE: pxToRem('11px'),
  },
};

const lightVariablesArr: UTColorVariable[] = exportVariables(WaterLightVariables);
const darkVariablesArr: UTColorVariable[] = exportVariables(WaterDarkVariables);

const sizeVariablesArr: UTSizeVariable[] = exportVariables(WaterSizeVariables, true);
export { lightVariablesArr, darkVariablesArr, sizeVariablesArr };
